import React from "react";
import { Link } from "react-router-dom";
import Nav from "../components/Nav";
import Footer from "../components/Footer";
import "../static/css/ServiceDetail.css";

function InsolvencyCasesPage() {
    return (
        <>
            <Nav />
            <div className="service-detail-container" style={{ paddingTop: "100px" }}>
                <div className="service-detail-content">
                    <div style={{ textAlign: "center", marginBottom: "3rem" }}>
                        <h1 style={{
                            fontSize: "2.5rem",
                            color: "#0a0e27",
                            marginBottom: "1rem"
                        }}>
                            Insolvency Cases
                        </h1>
                        <p style={{
                            fontSize: "1.1rem",
                            color: "#666",
                            maxWidth: "800px",
                            margin: "0 auto"
                        }}>
                            Comprehensive information on ongoing and completed insolvency cases
                        </p>
                    </div>

                    {/* Tabs for External Links */}
                    <div style={{
                        display: "flex",
                        justifyContent: "center",
                        gap: "1.5rem",
                        marginBottom: "3rem",
                        flexWrap: "wrap"
                    }}>
                        <Link
                            to="/ganga"
                            style={{
                                display: "inline-flex",
                                alignItems: "center",
                                gap: "0.5rem",
                                padding: "1rem 2.5rem",
                                fontSize: "1.1rem",
                                backgroundColor: "#d4af37",
                                color: "#0a0e27",
                                border: "none",
                                borderRadius: "0.5rem",
                                textDecoration: "none",
                                fontWeight: "600",
                                transition: "all 0.3s ease",
                                cursor: "pointer",
                                boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)"
                            }}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.backgroundColor = "#e5c158";
                                e.currentTarget.style.transform = "translateY(-3px)";
                                e.currentTarget.style.boxShadow = "0 6px 12px rgba(0, 0, 0, 0.15)";
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.backgroundColor = "#d4af37";
                                e.currentTarget.style.transform = "translateY(0)";
                                e.currentTarget.style.boxShadow = "0 4px 6px rgba(0, 0, 0, 0.1)";
                            }}
                        >
                            <span>🔗</span> Ganga
                        </Link>
                        <Link
                            to="/sakthiganesh"
                            style={{
                                display: "inline-flex",
                                alignItems: "center",
                                gap: "0.5rem",
                                padding: "1rem 2.5rem",
                                fontSize: "1.1rem",
                                backgroundColor: "#d4af37",
                                color: "#0a0e27",
                                border: "none",
                                borderRadius: "0.5rem",
                                textDecoration: "none",
                                fontWeight: "600",
                                transition: "all 0.3s ease",
                                cursor: "pointer",
                                boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)"
                            }}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.backgroundColor = "#e5c158";
                                e.currentTarget.style.transform = "translateY(-3px)";
                                e.currentTarget.style.boxShadow = "0 6px 12px rgba(0, 0, 0, 0.15)";
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.backgroundColor = "#d4af37";
                                e.currentTarget.style.transform = "translateY(0)";
                                e.currentTarget.style.boxShadow = "0 4px 6px rgba(0, 0, 0, 0.1)";
                            }}
                        >
                            <span>🔗</span> Sakthi Ganesh
                        </Link>
                    </div>

                    <div style={{
                        padding: "2rem",
                        backgroundColor: "#f8f9fa",
                        borderRadius: "0.5rem",
                        textAlign: "center"
                    }}>
                        <p style={{ fontSize: "1rem", color: "#666", margin: 0 }}>
                            Click on the tabs above to view detailed information about our insolvency cases.
                        </p>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    );
}

export default InsolvencyCasesPage;
